module.exports = __webpack_public_path__ + "img/testimoni-bapakhusen-abror.2041da80.jpeg";